import { AlertTriangle } from "lucide-react";
import { useCurrentUserShell } from "@/contexts/CurrentUserContext";

// Persistent banner shown when a Rarion superuser is acting inside an
// organisation they are not a real member of (story 8.3). The synthetic-
// membership flag is set server-side in ApplicationController#set_current_organisation.
//
// TODO (story 8.5): scrub the superuser's name from client-visible
// attribution on artefacts (reports, notes, interview guides). For now,
// downstream artefacts still render the actor's name; the banner makes the
// situation explicit to the operator.
export function SuperuserBanner() {
  const { currentMembership } = useCurrentUserShell();

  if (!currentMembership?.superuserSynthetic) return null;
  const membership = currentMembership;

  const orgName = membership.organisation?.name ?? "this organisation";

  const switchBack = async () => {
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
    const response = await fetch("/organisations/switch_back", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      },
    });
    if (response.ok) {
      window.location.reload();
    }
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-between gap-3 border-b border-amber-300 bg-amber-50 px-6 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle size={16} aria-hidden="true" />
        <span>
          Acting as Rarion staff in <strong>{orgName}</strong> — every action is audited.
        </span>
      </div>
      <button
        type="button"
        onClick={switchBack}
        className="rounded-md border border-amber-400 bg-amber-100 px-3 py-1 text-xs font-medium text-amber-900 transition-colors hover:bg-amber-200 dark:border-amber-600 dark:bg-amber-900 dark:text-amber-100 dark:hover:bg-amber-800"
      >
        Switch back
      </button>
    </div>
  );
}
